import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Subheader from '../../sharedComponent/Subheader';
import Star from "../../assets/images/Star.svg";
import dustbinImg from "../../assets/images/dustbinImg.svg";

const PetAllSellers = () => {
    return (
        <>
            <div className="allSellers" id="cx-main">
                <Subheader />
                <div className="innerSellerTab">
                    <div className="scroller">
                        <table className='tableMain'>
                            <thead className='tableHead'>
                                <tr>
                                    <th>Seller</th>
                                    <th>Price</th>
                                    <th>Delivery</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody className='tBody'>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="/Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="/Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="/Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="/Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="/Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="/Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="medicalDetailsFlex">
                                            <div className="ratingNname">
                                                <label htmlFor="" className='name'>Life care Medicle</label>
                                                <label htmlFor="" className='starNreview'>
                                                    <img src={Star} alt="" /> 4.3
                                                </label>
                                                <p className='paraTag'>tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="priceBox">
                                            <label htmlFor="" className='activePrice'>₹40.00</label>
                                            <label htmlFor="" className='mutedTxt'>₹50.00</label>
                                            <p className='paraTag'>10% Instant Discount on UPI Payment</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="insidePara">
                                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                Iste repudiandae rerum aspernatur velit facilis, impedit odit,</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="twoBtns">
                                            <button className='addBtn'><img src={dustbinImg} alt="" /> Add to Bag</button>
                                              <Link to="/Cart">
                                                <button className='buyBtn'>Buy Now</button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PetAllSellers;
